// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2ocpf","header":"PatientBlock_header__1-8Bx","label":"PatientBlock_label__dYKHw","option":"PatientBlock_option__FU1EZ"};